import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaMapMarkerAlt, FaSignOutAlt } from 'react-icons/fa';
import './StaticPages.css';

const About = () => {
  const { user, logout } = useAuth();
  const [isMobilePanelOpen, setIsMobilePanelOpen] = useState(false);

  return (
    <div className="page-root">
      {/* Mobile Toggle Button - Only visible on mobile */}
      {window.innerWidth <= 768 && user && (
        <button
          onClick={() => setIsMobilePanelOpen(!isMobilePanelOpen)}
          className="mobile-toggle"
        >
          {isMobilePanelOpen ? '✕' : '☰'}
        </button>
      )}

      {/* Mobile Backdrop - Only visible when panel is open */}
      {window.innerWidth <= 768 && isMobilePanelOpen && (
        <div 
          className="mobile-backdrop"
          onClick={() => setIsMobilePanelOpen(false)}
        />
      )}

      {/* Mobile Navigation Panel - Only visible on mobile */}
      {window.innerWidth <= 768 && user && (
        <div className={`mobile-panel ${isMobilePanelOpen ? 'open' : ''}`}>
          <div className="panel-content">
            {/* Close Button */}
            <div className="panel-header">
              <h2>Navigation</h2>
              <button
                onClick={() => setIsMobilePanelOpen(false)}
                className="panel-close"
              >
                ✕
              </button>
            </div>

            {/* Navigation Buttons */}
            <div className="panel-actions">
              <Link
                to="/"
                className="panel-nav-link"
                onClick={() => setIsMobilePanelOpen(false)}
              >
                <FaMapMarkerAlt size={16} />
                Back to Search
              </Link>
              
              <button
                onClick={() => {
                  logout();
                  setIsMobilePanelOpen(false);
                }}
                className="panel-nav-button"
              >
                <FaSignOutAlt size={16} />
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="content-card">
        <Link 
          to="/" 
          className="back-link"
        >
          ← Back to Home
        </Link>
        
        <h1 className="page-title">About LOOWAY</h1>
        
        <div className="content-body">
          <h2>Our Mission</h2>
          <p>
            Our mission is to improve the convenience and accessibility of toilet facilities for everyone in the United Kingdom.
            We understand that finding accessible toilet facilities during travel can be challenging, 
            especially for individuals with specific needs and hope that our platform helps to ease this process.
          </p>
          
          <h2>What We Do</h2>
          <p>
            Our intelligent journey planning platform harnesses data from Google Places and <a href="https://www.toiletmap.org.uk/dataset" target="_blank" rel="noopener noreferrer">The Toilet Map</a> © 2025 – <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="license noopener noreferrer">CC BY 4.0</a> to find the best toilet stops along your route, based on user selected preferences,
            whether you're traveling by car, public transport, or on foot. 
          </p>
          <h2>Key Features</h2>
          <ul>
            <li><strong>Smart Route Planning:</strong> Automatically finds optimal toilet stops along your journey</li>
            <li><strong>Accessibility Information:</strong> Ability to filter toilet stops by accessibility preferences</li>
            <li><strong>Real-time Data:</strong> Combines verified database information with live Google Places data</li>
            <li><strong>Opening Hours:</strong> Check if facilities are open at your planned journey time</li>
            <li><strong>AI Recommendations:</strong> Intelligent suggestions based on your preferences and needs</li>
            <li><strong>Community Contributions:</strong> Users can add new toilet locations to help others</li>
            <li><strong>Multiple Transport Modes:</strong> Support for driving, walking, and public transport</li>
          </ul>
          
          <h2>Community-Driven</h2>
          <p>
            LOOWAY grows stronger with every user contribution. Our community helps keep the database 
            up-to-date by adding new locations, updating information, and sharing their experiences. 
          </p>
          
          <h2>Get Involved</h2>
          <p>
            You can help improve LOOWAY by:
          </p>
          <ul>
            <li>Adding new toilet locations to our database</li>
            <li>Sharing your journey planning experiences</li>
            <li>Helping us identify areas that need more coverage</li>
          </ul>
          
          <p style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#666' }}>
            Thank you for choosing LOOWAY for your journey planning needs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
